import React, { useEffect, useState } from 'react';
import ProductListing from '../../components/ProductListing/ProductListing';
import FooterComp from '../../components/Footer/Footer';
import HeaderComp from '../../components/Header/Header';
import EndPoints from '../../config/config';
import SetHeaders from '../../config/SetHeaders';
import config from '../../config/seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import axios from 'axios';

const ProductListingContainer = ({ Header, Body, Footer, subBody, history }: any) => {
  const match = useRouter()
  const [seo, setSeo] = useState('')
  useEffect(() => {
    if (match.query.key === 'parts') {
      setSeo(config.parts);
    } else {
      setSeo(config.accessories);
    }
  }, [match])


  return (
    <React.Fragment>
      {Body && !Body.Seo && (
        <Head>
          <title>{seo}</title>
        </Head>
      )}
      {Body && <SetHeaders HEADERS={Body} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {subBody && (
          <div className="container app-prod-list-header">
            <h1 className="productListing-container-h1">{subBody[0].title}</h1>
            <div className="prod-list-desc" dangerouslySetInnerHTML={{ __html: subBody[0].description }} />
            <ProductListing data={Body} history={history} col={subBody[0].ProductGrid.numberOfColumns} />
          </div>
        )}
      </div>

      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps({ params }) {

  const body = await axios.get(EndPoints.endpoints.products, { params: { productType: params.key, _sort: 'displayOrder:asc' } })
  const subBody = await axios.get(`${EndPoints.serviceUrlMain}/${params.key}`)
  const props = axios.all([body, subBody]).then(
    axios.spread((...response) => {
      let body = response[0].data
      let subBody = response[1].data

      return {
        props: {
          Header: subBody.Header,
          Body: body,
          Footer: subBody.Footer.Footer,
          subBody: subBody.Body
        },
        revalidate: 3600
      }
    }
    ))
  return props

}

export async function getStaticPaths() {
  const paths = [
    { params: { key: 'accessories' } },
    { params: { key: 'parts' } },
  ]
  return {
    paths, fallback: false
  }
}

export default ProductListingContainer
